export interface FaqItem {
  id: number;
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 1,
    question: 'P站视频需要付费才能使用吗？',
    answer: 'P站视频提供免费和付费两种使用方式。免费用户可以观看大部分内容（可能包含广告），付费会员则享受无广告、高清画质、后台播放、离线下载等高级功能。建议新用户先用免费版体验，根据需求决定是否升级。',
  },
  {
    id: 2,
    question: '如何下载P站视频到本地？',
    answer: 'P站视频的下载方式取决于平台政策和视频本身的权限设置。部分视频支持平台内置下载功能，部分需要使用浏览器扩展或第三方工具。具体方法请参考本站"高清下载"分类下的多篇教程，涵盖多分辨率选择和批量下载策略。',
  },
  {
    id: 3,
    question: 'P站视频的搜索技巧有哪些？',
    answer: 'P站视频搜索支持多种高级技巧：使用双引号进行精确匹配、减号排除关键词、加号组合多关键词、时间范围筛选、时长筛选、标签组合搜索等。本站"搜索技巧"分类提供了从入门到进阶的完整搜索教程。',
  },
  {
    id: 4,
    question: '如何管理P站视频的收藏夹？',
    answer: '建议建立分类体系来管理收藏夹：按内容类型（教程、娱乐、参考等）创建不同的收藏夹，配合标签系统进行精细分类。定期整理收藏夹，删除失效内容，更新标签。具体方法详见"收藏管理"分类文章。',
  },
  {
    id: 5,
    question: 'P站视频支持哪些设备？',
    answer: 'P站视频支持网页端（PC/Mac）、移动应用（iOS/Android）、平板端和智能电视端。登录同一账号后，观看进度、收藏夹、播放列表等数据会自动跨设备同步，实现无缝切换观看体验。',
  },
  {
    id: 6,
    question: '为什么有些视频没有高清选项？',
    answer: '视频的可用分辨率取决于上传时的源文件质量。如果上传者只提供了标清或720P的源文件，则无法获取1080P或更高清的版本。此外，部分高清选项可能仅对付费会员开放。',
  },
  {
    id: 7,
    question: '如何在P站视频上保护个人隐私？',
    answer: '建议完成以下隐私设置：开启两步验证、设置强密码、管理观看历史可见性、设置收藏夹为私密、定期检查授权设备列表。本站"新手入门"分类中有详细的账号安全与隐私保护设置教程。',
  },
  {
    id: 8,
    question: 'P站视频的播放列表可以分享给别人吗？',
    answer: '可以。创建播放列表时可以设置可见性为"公开"，然后通过分享链接发送给其他人。部分平台还支持多人协作编辑播放列表，非常适合团队学习和内容策划场景。',
  },
];